import StateBoot from 'app/states/Boot';
import StateLoad from 'app/states/Load';
import StateWelcome from 'app/states/Welcome';
import StateCutscene from 'app/states/Cutscene';
import StateLocationLoader from 'app/states/LocationLoader';
import StateLevelSeek from 'app/states/LevelSeek';
import StateLevelHide from 'app/states/LevelHide';
import StateLevelTwoPlayers from 'app/states/LevelTwoPlayers';
import StateTwoPlayersSetup from 'app/states/TwoPlayersSetup';

export const STATE_BOOT = 'STATE_BOOT';
export const STATE_LOAD = 'STATE_LOAD';
export const STATE_WELCOME = 'STATE_WELCOME';
export const STATE_CUTSCENE = 'STATE_CUTSCENE';
export const STATE_LOCATION_LOADER = 'STATE_LOCATION_LOADER';
export const STATE_LEVEL_SEEK = 'STATE_LEVEL_SEEK';
export const STATE_LEVEL_HIDE = 'STATE_LEVEL_HIDE';
export const STATE_LEVEL_TWO_PLAYERS = 'STATE_LEVEL_TWO_PLAYERS';
export const STATE_TWO_PLAYERS_SETUP = 'STATE_TWO_PLAYERS_SETUP';

export const STATE_MAP = {
  STATE_BOOT: StateBoot,
  STATE_LOAD: StateLoad,
  STATE_WELCOME: StateWelcome,
  STATE_LOCATION_LOADER: StateLocationLoader,
  STATE_CUTSCENE: StateCutscene,
  STATE_LEVEL_SEEK: StateLevelSeek,
  STATE_LEVEL_HIDE: StateLevelHide,
  STATE_LEVEL_TWO_PLAYERS: StateLevelTwoPlayers,
  STATE_TWO_PLAYERS_SETUP: StateTwoPlayersSetup,
};
